/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemoveTeamMemberInput = {|
  clientMutationId?: ?string,
  userRowId?: ?any,
  teamRowId?: ?any,
|};
export type removeTeamMemberMutationVariables = {|
  input: RemoveTeamMemberInput
|};
export type removeTeamMemberMutationResponse = {|
  +removeTeamMember: ?{|
    +boolean: ?boolean
  |}
|};
export type removeTeamMemberMutation = {|
  variables: removeTeamMemberMutationVariables,
  response: removeTeamMemberMutationResponse,
|};
*/


/*
mutation removeTeamMemberMutation(
  $input: RemoveTeamMemberInput!
) {
  removeTeamMember(input: $input) {
    boolean
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemoveTeamMemberInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveTeamMemberPayload",
    "kind": "LinkedField",
    "name": "removeTeamMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeTeamMemberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeTeamMemberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "removeTeamMemberMutation",
    "operationKind": "mutation",
    "text": "mutation removeTeamMemberMutation(\n  $input: RemoveTeamMemberInput!\n) {\n  removeTeamMember(input: $input) {\n    boolean\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '10a6ccac4c520b5e07e5c7fa5335ca33';

module.exports = node;
